import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import { Row, Col} from 'react-bootstrap';
import buildUrl from "build-url-ts";
import ZohoConfigurationPage from './ZohoConfigurationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import DeactivatedZoho from 'src/legacy/images/deactivated_salesforce.svg';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import { localizedStrings } from 'src/localization/index.jsx';
import DOMPurify from 'dompurify';
import { ZohoSideBar } from './ZohoSideBar';
import { ZohoOnboardingView } from './ZohoOnboardingView';
import _ from 'lodash';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
class ZohoView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      deleteConfirmation: false,
      showIntergrationOnboarding: _.get(this.props, "integration") == 0,
      isScrollDisabled: false,
      selectedTab: null,
      integration: this.props.integration,
      integrationCreatedBy: _.get(this.props.integration, "createdBy") || '',
    };

    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedZoho = localizedStrings.components.integrations.zoho;

    this.showIntergrationOnboarding = this.showIntergrationOnboarding.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);
    this.canEdit = this.canEdit.bind(this);
  }

  componentDidMount() {

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.zoho;
    const sections = integration.sections;
      this.setState({
        selectedTab: sections[0].id
      })
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }
  canEdit() {
    if (_.get(this.props, "user.admin")) {
      return true;
    } else if (_.get(this.state, "integrationCreatedBy")) {
      return (_.get(this.state, "integrationCreatedBy.id") === (_.get(this.props, "user.id")));
    }
    return false;
  }
  showIntergrationOnboarding() {
    this.setState({
      showIntergrationOnboarding: !this.state.showIntergrationOnboarding,
    });
  }
  disableScroll(value){
    this.setState({
      isScrollDisabled: value
    })
  }
  handleScroll(e){

    if(this.state.isScrollDisabled){
      return;
    }

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.zoho;
    const sections = integration.sections;
     
    if(sections) { 
    for (let i = 0; i < sections.length; i++) {
      const offsets = document.getElementById(`${sections[i].id}`)?.getBoundingClientRect();
      const position = offsets?.top;
      
      if(offsets) {
        if (e.target.scrollTop >= position) {
          this.setState({
            selectedTab: sections[i].id
          })
        }
      }
    }
  }
}

  render(){
    if (this.props.loading) {
      return this._renderLoadingMessage();
    }

    var isAuthenticated = false; 

    if(_.get(this.props, 'integration.state.code') === 'ok' && !_.get(this.props, 'error')) {

        isAuthenticated = true;
    }
    var isTokenExpired = _.get(this.props, 'integration.state.code') === "auth_error";

    return (
      <div className={styles.content}>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <ZohoSideBar
              integration={this.props.integration}
              handleAuthenticate={this.handleAuthenticate}
              showIntergrationOnboarding={this.showIntergrationOnboarding}
              _handleDeactivateClicked={this._handleDeactivateClicked}
              canEdit={this.canEdit}
              deactivating={this.props.deactivating}
              isAuthenticated={isAuthenticated}
              authenticating={this.props.authenticating}
              isTokenExpired={isTokenExpired}
              navigate={this.props.navigate}
              isShowIntegrationOnboarding={this.state.showIntergrationOnboarding}
              handleIntegrationsBackButton={this.props.handleIntegrationsBackButton}
            />
          </Col>
          <Col md={9} id="right" className={styles.right} onScroll={(e) => this.handleScroll(e)}>
          {(this.props.integrationsLoading) &&
            (<p className={styles.integrationLoading}>{this.localizedCommons.loading.loading}...</p>)
            }
          {!isAuthenticated && _.size(this.props.integration) > 0 && !this.state.showIntergrationOnboarding && (
            <div className={styles.errorContainer}>
              <PlaceholderEmptyMessage
                title={this.localizedZoho.error_messages.token_expired.title}
                message={this.canEdit() ? this.localizedZoho.error_messages.token_expired.sub_text : this.localizedZoho.error_messages.token_expired.non_admin}
                image={DeactivatedZoho}
                visible={true}
            />
            </div>
            )}
            
            {(_.size(this.props.integration) == 0 || this.state.showIntergrationOnboarding) && (

              <ZohoOnboardingView
                selectedTab={this.state.selectedTab}
                disableScroll={this.disableScroll}
              />
            )}

            {!isAuthenticated && !this.props.integration && !isAuthenticated && this.state.showIntergrationOnboarding && 
              <div className={styles.authorize}>
                <h3>{ this.localizedZoho.authenticate.title }</h3>
                <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.localizedZoho.authenticate.sub_text)}} />
                <button className={styles.authButton} onClick={this.handleAuthenticate} disabled={this.props.authenticating}>
                  {this.props.authenticating &&
                    `${this.localizedIntegrations.actions.authenticating}...`
                  }

                  {!this.props.authenticating &&
                     this.localizedIntegrations.actions.authenticate
                  }
                </button>
              </div>
            }
            {isAuthenticated && this.props.integration && !this.state.showIntergrationOnboarding &&
              <ZohoConfigurationPage integration= {this.props.integration}/>
            }  
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name={this.localizedZoho.deactivate_slider.title}
          type="zoho"
          message={localizedStrings.formatString(
            this.localizedZoho.deactivate_slider.sub_text,
            {
              email: (this.props.integration && _.get(this.props, 'integration.configuration.email', ""))
            }
          )}
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
            deleteConfirmation: false
           })
          }}
        />
      </div>
    );
  }
  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={this.localizedZoho.loading}
        visible={this.props.loading}
      />
    )
  }

  handleAuthenticate(){
    //Calculate Position
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;
    
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
    
    var w = 0.8 *width;
    var h = 0.8 * height;
    
    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
      
    const url = buildUrl(apiUrl, {
      path: `/api/2.0/integrations/zoho/authorize`
    })

    var newWindow = window.open(url, `Authorize zoho Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow.focus) {
        newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, this.handleAuthenticateEvent, false);
    return false; 
  }

  handleAuthenticateEvent(e) {

    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == 'ZOHO_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var location = e.data.payload.location;
      var error = e.data.payload.error;
      this.props.trackAdoptionMetricsForPluginConnectedEvent('Zoho')
      if (!error) {
        this.props.authenticateAccount(code, location);
      }

      deEventer(messageEvent, this.handleAuthenticateEvent, false);
    }
  }

}

export default ZohoView;